var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 124,
    viewBox: "0 0 97 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0312 72.225C12.0312 70.583 13.3623 69.252 15.0043 69.252H22.5359C24.1779 69.252 25.5089 70.583 25.5089 72.225V80.9458V99.874V105.721C25.5089 107.363 24.1779 108.694 22.5359 108.694H15.0043C13.3623 108.694 12.0312 107.363 12.0312 105.721V72.225Z",
    fill: "#E7EFFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5089 99.874V105.721C25.5089 107.363 24.1779 108.694 22.5359 108.694H15.0043C13.3623 108.694 12.0312 107.363 12.0312 105.721V72.225C12.0312 70.583 13.3623 69.252 15.0043 69.252H22.5359C24.1779 69.252 25.5089 70.583 25.5089 72.225V80.9458M25.5089 99.874L44.9892 107.313C52.0569 110.012 59.9535 109.469 66.5847 105.827L82.3853 97.1489C84.9955 95.7153 85.7155 92.2934 83.9042 89.9295C82.5039 88.102 80.014 87.5071 77.9388 88.5041L68.043 93.2588C66.4032 94.0466 64.7022 94.6508 62.9689 95.072M25.5089 99.874V80.9458M44.338 92.5406L44.5328 92.647C50.2174 95.752 56.7977 96.5717 62.9689 95.072M62.9689 95.072L64.1703 93.2036C65.159 91.6661 65.3535 89.7486 64.6936 88.0439C63.8845 85.9538 61.9295 84.5286 59.6921 84.3977L50.9625 83.8872C48.1313 83.7217 45.648 82.0517 43.7386 79.9547C41.978 78.021 39.6584 76.2316 37.2028 76.0899C32.0496 75.7926 28.581 78.2701 25.5089 80.9458",
    stroke: "#065EEA",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.971 56.5675C84.971 66.5287 76.8959 74.6038 66.9347 74.6038C56.9736 74.6038 48.8984 66.5287 48.8984 56.5675C48.8984 46.6064 56.9736 38.5312 66.9347 38.5312C76.8959 38.5312 84.971 46.6064 84.971 56.5675Z",
    fill: "#EEF9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2049 57.2612L64.7545 62.6127L74.4664 50.4233M84.971 56.5675C84.971 66.5287 76.8959 74.6038 66.9347 74.6038C56.9736 74.6038 48.8984 66.5287 48.8984 56.5675C48.8984 46.6064 56.9736 38.5312 66.9347 38.5312C76.8959 38.5312 84.971 46.6064 84.971 56.5675Z",
    stroke: "#4DBBFF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.5da7c15e8241456733ba24094fb31635.svg";
export { ForwardRef as ReactComponent };